import classNames from 'classnames';
import React, { useContext } from 'react';
import { CnList } from '../cn-list';
import { CnCheckbox } from '../cn-checkbox';
import SelectContext from './context';
export default function Option(props) {
    const { disabled = false, children, className, value, isNew = false, onClick = () => { }, selected = false, multiple = true, title, ...others } = props;
    const { prefix } = useContext(SelectContext);
    const clsPrefix = `${prefix}select-option`;
    return (React.createElement(CnList.Item, { ...others, className: classNames(clsPrefix, className, {
            [`${clsPrefix}--disabled`]: disabled,
            [`${clsPrefix}--selected`]: selected,
        }), title: children || title, media: multiple ? (React.createElement(CnCheckbox, { checked: selected, disabled: disabled || isNew, className: `${clsPrefix}-checkbox` })) : undefined, onClick: () => {
            if (!disabled) {
                onClick(value);
            }
        } }));
}
Option.displayName = 'CnSelectOption';
